// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Button from 'presentations/views/components/atoms/Button';
import { mediaMax, spacing } from 'presentations/views/styles';
import {
  blackFix,
  gray01,
  gray04,
  whiteFix,
} from 'presentations/views/styles/color';

interface Props {
  isDisabled?: boolean;
  isLoading?: boolean;
  onSubmit?: any;
  onCancel?: any;
  submitLabel?: string;
  cancelLabel?: string;
  color?: string;
  isLightColor?: boolean;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  return (
    <ButtonContainer>
      {props.onCancel && (
        <CancelButton
          isDisabled={props.isLoading}
          onClick={props.onCancel}
          size={'large'}
        >
          {props.cancelLabel || t('Cancel')}
        </CancelButton>
      )}
      {props.onSubmit && (
        <SubmitButton
          size={'large'}
          type="submit"
          color="primary"
          onClick={props.onSubmit}
          isDisabled={props.isDisabled}
          isLoading={props.isLoading}
          themeColor={props.color}
          isThemeColorLight={props.isLightColor}
        >
          {props.submitLabel || t('Submit')}
        </SubmitButton>
      )}
    </ButtonContainer>
  );
}

const ButtonContainer = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;

  ${mediaMax.smartphone} {
    flex-direction: column-reverse;
    margin: 0;
    width: 100%;
  }
`;

const BaseButton = styled(Button)`
  width: 168px;
  ${mediaMax.smartphone} {
    margin: 0;
    margin-bottom: ${spacing(8)};
    width: 100%;
    padding: ${spacing(8)} ${spacing(16)};
  }
`;
const SubmitButton = styled(BaseButton)<{
  themeColor?: string;
  isThemeColorLight?: boolean;
}>`
  background-color: ${(props) => props.themeColor || ''};
  color: ${(props) => (props.isThemeColorLight ? blackFix : whiteFix)};
  :hover {
    background-color: ${(props) => props.themeColor || ''};
    color: ${(props) => (props.isThemeColorLight ? blackFix : whiteFix)};
  }
`;
const CancelButton = styled(BaseButton)`
  margin-right: ${spacing(20)};
`;
